const TEXT = {
  "general": {
    "all_rights_reserved": "All Rights Reserved",
    "close": "Close",
    "mac_input_message": "Please input your mac address",
    "mac_input_valid_message": "Mac address is valid",
    "mac_input_not_valid_message": "Mac address is not valid",
    "mac_input_placeholder": "Mac address",
    "login": "Login",
  },
  "pages": {
    "voucher_code": {
      "page_name": "Voucher Code",
      "qa_modal_title": "Activate",
      "qa_modal_voucher_code_input_message": "Please input voucher code",
      "qa_modal_voucher_code_input_placeholder": "Enter voucher code",
      "qa_modal_button_title": "Activate",
      "qa_modal_success_message": "Activate"
    },
    "simple_activation": {
      "page_name": "Simple Activation",
      "title": "By activating you will have access to the Media player for LifeTime",
      "agree_with_all": "Privacy Policy",
      "mac_adress_modal_title": "You can find your MAC address in the application on TV on the settings right bottom corner",
      "warning_text": "ATTENTION! THE APP IS ONLY A MEDIA PLAYER. WE DO NOT PROVIDE ANY TYPE OF CONTENT!"
    },
    "installation_guide": {
      "page_name": "Installation Guide",
      "title": "App Installation Guide",
      "step": "step",
      "step_1_text": "Enim nunc faucibus a pellentesque sit amet.",
      "step_2_text": "Sed lectus vestibulum mattis ullamcorper dolor.",
      "step_3_text": "Enim nunc faucibus a pellentesque sit amet.",
      "step_4_text": "Enim nunc faucibus a pellentesque sit amet.",
      "step_5_text": "Enim nunc faucibus a pellentesque sit amet.",
      "step_6_text": "Enim nunc faucibus a pellentesque sit amet."
    },
    "home": {
      "page_name": "Home",
      "header_title": "Relax play",
      "header_second_title": "Relax play  is a general media player and it does not include any content. You have to provide your own content. Relax play is not responsible for the content you use in the app",
      "header_description": "We don't offer any channels or any copyright content of any kind",
      "header_activate_app_button": "Activate app",
      "header_upload_playlist_button": "Upload playlist",
      "section_one_title": "Launch Your Relax Play In 7 Days",
      "section_one_description": "With Relax Play you can use all modern functional lists of the players...",
      "section_two_title": "Watch Live TV with comfort",
      "section_two_description": "Our good organized UI will bring you a new level of watching live tv programs. Pick a channel, Watch, Save to favorites, and the app will start suggesting to you what you like to watch.",
      "section_three_title": "Find content fastet",
      "section_three_description": "A single place to search for your Movies, Tv shows, or LiveTV. Search and start instantly your watch session without 0 lose of your time.",
      "news_section_title": "Latest News",
      "news_section_view_more": "View more",
      "Download": "Download",
      "Download_for_free": "Download for free",
    },
    "activation": {
      "page_name": "Activation",
      "choose_plan_text": "You can now activate here and choose the plan that suits you\n\nVery important! You have 7 days to test the application before paying it, Please DO NOT pay if something is not working for you, because the payment won't solve any of these problems. And you will not be refunded. If you use a stolen card, your TV will be banned and its IP address reported.",
      "direct_pay": "Direct pay",
      "gift_code": "Gift code",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "one_time": "One time",
      "agree_with_all": "Agree with all",
      "agree_with_all_description": "You must agree to our privacy policy and terms of use before activation",
      "activate_for_qa_description": "Activatee tv device by voucher code for Beta testers and LG / Samsung QA team",
      "activate_qa_button_text": "Activate",
      "payments_methods_disabled": "No payment method activated",
      "gift_code_input_placeholder": "Enter your GIFT code",
      "gift_code_input_message": "Please input your GIFT code",
      "or": "Or",
      "success_message": "Your activation was successfully done!",
      "error_message": "Invalid code",
      "button_text": "Activate",
      "qa_modal_title": "Activate",
      "qa_modal_voucher_code_input_placeholder": "Enter voucher code",
      "qa_modal_voucher_code_input_message": "Please input voucher code",
      "qa_modal_success_message": "Activate",
      "qa_modal_button_title": "Activate",
      "stripe_button_text": "Pay By Card",
      "email_modal_button_text": "Next"
    },
    "upload_playlist": {
      "page_name": "Upload playlist",
      "title": "Upload Playlist",
      "description": "Choose how you want to load your playlist into the application",
      "url": "Url",
      "xtream_account": "Xtream account",
      "mac_address": "Mac address",
      "playlist_name": "Playlist name",
      "playlist_url": "Playlist url",
      "host": "Host",
      "username": "Username",
      "password": "Password",
      "url_button_title": "Upload",
      "xtream_button_title": "upload by xtream",
      "playlist_name_message": "Please input playlist name",
      "playlist_url_message": "Please input playlist url",
      "host_message": "Please input host",
      "username_message": "Please input username",
      "password_message": "Please input password",
      "success_message": "Playlist successfully added",
      "playlist_epg_url": "Playlist EPG url"
    },
    "reseller": {
      "page_name": "Reseller",
    },
    "register": {
      "register": "Reseller Register",
      "reseller_login": "Reseller Login",
      "page_name": "Register",
      "title": "Become a partner",
      "subtitle": "More info about partners",
      "company_input_placeholder": "Company name",
      "company_input_message": "Please input company name!",
      "name_input_placeholder": "Name",
      "name_input_message": "Please input name!",
      "surname_input_placeholder": "Surname",
      "surname_input_message": "Please input surname!",
      "email_input_placeholder": "Email",
      "email_input_message": "Please input valid email!",
      "password_input_placeholder": "Password",
      "password_message": "Please input your password!",
      "password_length_message": "Password must be minimum 8 characters!",
      "country_select_placeholder": "Select country",
      "country_select_message": "Please select country!",
      "address_input_placeholder": "Address",
      "address_input_message": "Please input address!",
      "phone_input_message": "Please input phone!",
      "choose_partner_type": "Please choose partner type!",
      "reseller": "Reseller",
      "referral": "Referral",
      "accept_text": "Accept privacy policy and usage",
      "agree_text": "Agree with all",
      // "step_one_button_title": "Next",
      // "step_two_button_title": "Register",
      "select_reseller_message": "Member must be a Reseller or Referral",
      "register_success_message": "Registred",
      "button_text": "Register",
      "register_as": "Please choose partner type",
      "Your registration is successfully done.": "Your registration is successfully done."
    },
    "news": {
      "page_name": "News",
      "title": "News"
    },
    "current_news": {
      "subtitle": "You May Be Interested Also"
    },
    "contact_us": {
      "page_name": "Contact Us",
      "title": "Contact Us",
      "description": "Please fill out the form below to contact us",
      "location_title": "Our location",
      "phone_title": "Phone number",
      "email_title": "Email address",
      "title_input_placeholder": "Your title",
      "email_input_placeholder": "Your email",
      "message_input_placeholder": "Your message",
      "title_input_message": "Please input your title!",
      "email_input_message": "Please input valid email!",
      "email_input_validation_message": "Please input valid email!",
      "email_input_message": "Please input email!",
      "message_input_message": "Please input message!",
      "button_title": "Send message",
      "submition_success_message": "Your message was successfully sent!",
      "error_message": "Something went wrong",
    },
    "privacy": {
      "page_name": "Privacy Policy",
      "content": "<p>We invite you to read these terms and conditions of online sales of Relaxplay site : https:// Relaxplay.net/#/home The validation of your online transaction form is considered as an irrevocable acceptance of these terms&nbsp;</p><p><br></p><p><br></p><p>1. Preamble</p><p><br></p><p>The following online sales terms govern all transactions established through the Relaxplay Website . Any transaction processed through this web site assumes the unconditional and irrevocable acceptance of these conditions by the customer.</p><p><br></p><p><br></p><p>2. Purpose</p><p><br></p><p>These terms are intended to define the rights and obligations of the parties in the context of the online sales done via the Relaxplay Website.</p><p><br></p><p><br></p><p>3. Sales</p><p><br></p><p>The customer connects to the Relaxplay Website and selects subscriptions that he wishes to buy. He then fills his identity information, accepts the terms and clicks on the “Pay” button. The customer is thus redirected to the PayPal online secure payment platform where he completes his payment information and validates the payment. All of our Sales are final and no refunds are allowed even after the termination of the app and or the activation of the user’s account. The `Relaxplay Website reserves the right to terminate any user’s activation at any time and without providing any reason for the termination.</p><p><br></p><p><br></p><p>4. Payment Methods</p><p><br></p><p>To pay on Internet by credit card, the customer is called to enter his payment card credentials on the secure payment page. When the transaction is accepted by the bank, the settlement to debit his account is made in the working-day following the date of the transaction confirmation. Online payment with credit cards is secured by the PayPal that provides a fully secure payment service. The customer guarantees the Relaxplay Website and the company Relaxplay that he has enough funds required when using the payment method chosen by him during the payment validation. When paying by credit card, the conditions of this payment method that are contained in the agreements established between the customer and his issuer bank, and between the Relaxplay Website and his bank, are applied.</p><p><br></p><p><br></p><p>5. Data Privacy</p><p><br></p><p>The information requested from the customer during the online payment are required to process the online transaction. They are treated confidentially. The customer has the right to consult or rectify his personal data by sending a request electronic mail to the following email address support@relaxplay.com.</p><p><br></p><p><br></p><p>6. Proof of payment</p><p><br></p><p>The data stored on the PayPal online platform for the account of the Relaxplay Website are considered as proof of payment for the online transaction made by the customer.</p><p>RELAXPLAY</p>",
    },
    "terms_of_use": {
      "page_name": "Terms of use",
      "content": "<p>Terms of use</p><p><br></p><p>The application Relaxplay.net MediaPlayer is delivered without any content. In addition, no content is provided from the application even after activating it on our website. The information displayed at the beginning includes the MAC address as well as the website so that clients can activate the application once for life. The Relaxplay MediaPlayer app has a free 5-days trial period once installed on your smart TV to test the features of the app. The MAC address and the URL are essential for the proper functioning of the application. Relaxplay MediaPlayer does not provide any content or subscription. The content and subscriptions provided under the Relaxplay MediaPlayer Relaxplay are frauds. Relaxplay MediaPlayer disclaims any responsibility for the use of fraudulent content. The application Relaxplay MediaPlayer or it is entitled can not be held as responsible for the quality or interruptions of the content used on Relaxplay MediaPlayer, Relaxplay MediaPlayer only provides a media player. The application Relaxplay MediaPlayer does not provide any advertising for content providers or subscriptions and reserves the right to sue anyone who uses our name or logo for advertising purposes.</p><p><br></p><p><br></p><p>After accepting the above conditions, no refund will be granted under any circumstances.</p><p><br></p><p>Note: If you are using a stolen card, your mac will be banned and its IP address will be reported.</p><p><br></p><p><br></p><p>Relaxplay is owned and operated by Relaxplay which reserves the right to restrict access to the app change its pricing and modify the terms of use at any time without the consent of its user. It is the user’s responsibility to stay up to date with the terms.</p><p><br></p>"
    },
    "terms_of_online_sale": {
      "page_name": "Terms of Online Sale",
      "content": "<p>Terms of Online Sale</p><p><br></p><p>We invite you to read these terms and conditions of online sales of Relaxplay site : https:// Relaxplay.net/#/home The validation of your online transaction form is considered as an irrevocable acceptance of these terms&nbsp;</p><p><br></p><p><br></p><p>1. Preamble</p><p><br></p><p>The following online sales terms govern all transactions established through the Relaxplay Website . Any transaction processed through this web site assumes the unconditional and irrevocable acceptance of these conditions by the customer.</p><p><br></p><p><br></p><p>2. Purpose</p><p><br></p><p>These terms are intended to define the rights and obligations of the parties in the context of the online sales done via the Relaxplay Website.</p><p><br></p><p><br></p><p>3. Sales</p><p><br></p><p>The customer connects to the Relaxplay Website and selects subscriptions that he wishes to buy. He then fills his identity information, accepts the terms and clicks on the “Pay” button. The customer is thus redirected to the PayPal online secure payment platform where he completes his payment information and validates the payment. All of our Sales are final and no refunds are allowed even after the termination of the app and or the activation of the user’s account. The `Relaxplay Website reserves the right to terminate any user’s activation at any time and without providing any reason for the termination.</p><p><br></p><p><br></p><p>4. Payment Methods</p><p><br></p><p>To pay on Internet by credit card, the customer is called to enter his payment card credentials on the secure payment page. When the transaction is accepted by the bank, the settlement to debit his account is made in the working-day following the date of the transaction confirmation. Online payment with credit cards is secured by the PayPal that provides a fully secure payment service. The customer guarantees the Relaxplay Website and the company Relaxplay that he has enough funds required when using the payment method chosen by him during the payment validation. When paying by credit card, the conditions of this payment method that are contained in the agreements established between the customer and his issuer bank, and between the Relaxplay Website and his bank, are applied.</p><p><br></p><p><br></p><p>5. Data Privacy</p><p><br></p><p>The information requested from the customer during the online payment are required to process the online transaction. They are treated confidentially. The customer has the right to consult or rectify his personal data by sending a request electronic mail to the following email address support@relaxplay.com.</p><p><br></p><p><br></p><p>6. Proof of payment</p><p><br></p><p>The data stored on the PayPal online platform for the account of the Relaxplay Website are considered as proof of payment for the online transaction made by the customer.</p><p>RELAXPLAY</p>"
    },
    "payment_error": {
      "page_name": "Payment error",
      "message": "Please check with your payment provider about the status of the account or contact our support"
    },
    "payment_success": {
      "page_name": "Payment success",
      "message": "Your payment was done successfully. The app must be activated automatically if it's not please restart the app or contact support"
    },
    "login": {
      "page_name": "Upload Playlist",
      "title": "Upload Playlist",
      "mac_input_placeholder": "Device Mac",
      "mac_input_message": "Please input device mac",
      "device_key_input_placeholder": "Please input Device key",
      "device_key_input_message": "Please input device key",
      "code_input_placeholder": "OTP",
      "code_input_message": "Please input OTP",
      "enter_code": "Enter code",
      "device_key": "Device Key",
      "code_description": "You will get an OTP on your TV after filling in the MAC",
      "device_key_description": "You can find device key on TV  settings section",
      "button_text": "Login By Mac",
      "code_modal_button_text": "Submit",
      "log_out": "Log Out",
    },
    "login_2": {
      "page_name": "Manage playlist",
      "mac": "MAC address",
      "model": "Device Model",
      "date": "Expire date",
      "delete_playlist_modal_title": "Are you sure you want to delete?",
      "add_playlist_modal_title": "Add new playlist",
      "edit_playlist_modal_title": "Edit playlist",
      "url": "Url",
      "xtream_account": "Xtream account",
      "mac_address": "Mac address",
      "playlist_name": "Playlist name",
      "playlist_url": "Playlist url",
      "host": "Host",
      "username": "Username",
      "password": "Password",
      "url_button_title": "Upload",
      "playlist_name_message": "Please input playlist name",
      "playlist_url_message": "Please input playlist url",
      "password_input_message": "Please input your password!",
      "confirm_password_input_message": "Please confirm your password!",
      "confirm_password_input_message_2": "The two passwords that you entered do not match!",
      "host_message": "Please input host",
      "username_message": "Please input username",
      "password_message": "Please input password",
      "Enter your PIN": "Enter your PIN",
      "set_pin": "Set PIN",
      "confirm_pin": "Confirm PIN",
      "other_m3u8": "Other M3u8",
      "file": "File",
      "SAVE": "SAVE",
      "my_profile": "My Profile",
      "my_playlist": "My Playlists",
      "protected_playlist": "The playlist is protected",
      "m3u8": "Please select m3u8 file",
      "all": " All",
      "hide": " Hide",
      "lock": "Lock",
      "protect_playlist": "Protect Playlist",
      "package_name": "Package Name",
      "payment_date": "Payment date",
      "package_type": "Package type",
      "price": "Price",
      "transaction_id": "Transaction ID",
      "method": "Method",
      "status": "Status",
      "log_out": "Log Out",
      "playlist_epg_url": "Playlist EPG url",
    },
    "playlist": {
      "button_text": "Add Playlists",
      "logout_button_text": "LOGOUT",
      "title": "Manage playlist",
      "url": "Url",
      "file": "File",
      "xtream_account": "Xtream account",
      "mac_address": "Mac address",
      "status": "Status",
      "playlist_name": "Playlist name",
      "playlist_url": "Playlist url",
      "host": "Host",
      "username": "Username",
      "password": "Password",
      "url_button_title": "Upload",
      "xtream_button_title": "upload by extream",
      "playlist_name_message": "Please input playlist name",
      "playlist_url_message": "Please input playlist url",
      "host_message": "Please input host",
      "username_message": "Please input username",
      "password_message": "Please input password",
      "success_message": "Playlist successfully added",
      "playlist_epg_url": "Playlist EPG url",
      "protect_playlist": "Protect Playlist",
      "Activation expired": "Activation expired",
      "Free trial expired": "Free trial expired",
      "set_pin": "Set PIN",
      "confirm_pin": "Confirm PIN",
      "Enter your PIN": "Enter your PIN",
      "Please input PIN": "Please input PIN",
      "Enter": "Enter",
      delete_playlist_modal_title: "Are you sure you want to delete?",
      Cancel: "Cancel",
      Yes: "Yes",
      save: "Save",
      playlist_file_message: "Please select m3u8 file!",
      "Pin is required": "Pin is required!",
      "Please enter a valid URL!": "Please enter a valid URL!",
      "Pins must match!": "Pins must match!",
      "Are you sure you want to log out?": "Are you sure you want to log out?",
      "Log out": "Log out"
    },
    "multiple_device_login": {
      "page_name": "Multiple device login",
      "title": "Login",
      "login": "Login",
      "logout": "Logout",
      "button_text": "LOGIN",
      "register_link": "Create Account",
      "email_placeholder": "Email",
      "password_placeholder": "Password",
      "registration": "Registration",
      "password_message": "Please input your password",
      "email_message": "Please input your E-mail!",
      "email_validation_message": "The input is not valid E-mail!",
      "devices": "Devices",
      "add_device": "Add device",
      "code_description": "You will get an OTP on your TV after filling in the MAC",
      "device_key_description": "You can find device key on TV  settings section",
      "device_key_input_placeholder": "Please input Device key",
      "device_key_input_message": "Please input device key",
      "code_input_placeholder": "OTP",
      "code_input_message": "Please input OTP",
      "delete_playlist_modal_title": "Are you sure you want to delete?",
      "enter_code": "Enter code",
      "device_key": "Device Key",
      "mac_modal_desc": "Enter device mac and activate it",
      "mac_modal_warning_text": "Make sure that you have already downloaded application to you device"
    }
  }
};

export default TEXT;


// todo give object to Suren to put in 'traslations' object under 'en' key 